/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable import/no-unresolved */
import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Typography,
  FormControl,
  Radio,
  RadioGroup,
  FormControlLabel,
  Box,
  Card,
  IconButton,
  Container,
  Divider,
  MenuItem,
  Snackbar,
  Grid,
  CardHeader,
  CardContent,
  Avatar,
} from "@mui/material";
import PaymentIcon from '@mui/icons-material/Payment';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import StorefrontIcon from '@mui/icons-material/Storefront';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';

import ShopHeaderMini from "components/elements/main/ShopHeaderMini";
import ButtonComponent from "components/Button";
import RadioButtonFieldComponent from "components/RadioButtonField";
import { DATE_FORMAT } from "config/constants";
import {getImage, getLocalDate, getTimeSlot, isMarketPlace} from "helpers/utils";

import * as Actions from "actions";
import * as ActionsBase from "actions/core/core.actions";
import * as ActionTypes from "constants/ActionTypes";
import { getCartTotal } from "services";
import {Pace} from "components/Atoms";

const ShopPaymentCheckout = (props) => {

  const { location, isLoading, shopinfo, wholesale, bootupInfo, match } = props;

  const {
    address, items, shipping, total_price, total_shipping, shippingoption, total_order, total_tax, order_type, delivery_date, delivery_time
  } = location.state || {};

  const shopId = (isMarketPlace() ? match.params.shopId : bootupInfo.appState.subdomain_shopId);

  const [state, setState] = useState({
    address,
    paymentoption: "upibased",
    shippingoption: order_type,
    delivery_date,
    delivery_time,
  });

  useEffect(() => {
    switch (props.reqStatus) {
      case ActionTypes.USER_GENERATE_PRODUCT_ORDER_SUCCESS:
        if (props.serviceCode === 200) {
          if (props.bootupInfo.appState.isWebsite) {
            props.history.push({
              pathname: "/cart/order-success",
              state: {
                // payment: { paymentID: props.order.order.order_id },
                order_id: props.order.order.order_id,
                _id: props.order.order._id,
                status: props.order.order.status,
                items: props.order.order.products,
                shipping: props.order.order.shipping,
                created_at: props.order.order.created_at,
                order_type: props.order.order.order_type,
                delivery_date: props.order.order.delivery_date,
                delivery_time: props.order.order.delivery_time,
                total_price: props.order.order.total_price,
                total_shipping: props.order.order.total_shipping,
                shippingoption: props.order.order.shippingoption,
                total_order: props.order.order.total_order,
                total_tax: props.order.order.total_tax,
                symbol: props.symbol,
              },
            });
          } else {
            props.history.push({
              pathname: `/shop/${props.bootupInfo.appState.subdomain_shopId}/cart/order-success`,
              state: {
                // payment: { paymentID: props.order.order.order_id },
                order_id: props.order.order.order_id,
                _id: props.order.order._id,
                status: props.order.order.status,
                items: props.order.order.products,
                shipping: props.order.order.shipping,
                created_at: props.order.order.created_at,
                order_type: props.order.order.order_type,
                delivery_date: props.order.order.delivery_date,
                delivery_time: props.order.order.delivery_time,
                total_price: props.order.order.total_price,
                total_shipping: props.order.order.total_shipping,
                shippingoption: props.order.order.shippingoption,
                total_order: props.order.order.total_order,
                total_tax: props.order.order.total_tax,
                symbol: props.symbol,
              },
            });
          }
        }
        break;
      default:
        break;
    }
  }, [props.reqStatus]);

  const handlePaymentOption = (event) => {
    setState({
      paymentoption: event.target.value,
    });
  };

  const handlePlaceOrder = () => {
    if ((state.isDelivery && !state.address) || isLoading) { return; }

    props.generateProductOrder(state,
      props.bootupInfo.appState.subdomain_shopId,
      props.bootupInfo.appState.isWebsite);
  };

  const handlePage = (page) => () => {
    props.history.push({
      pathname: page,
    });
  };

  const {
    order, cartItems, symbol, total, shippingAddress,
  } = props;

  // Paypal Integration
  const onSuccess = (payment) => {
    if (props.bootupInfo.appState.isWebsite) {
      props.history.push({
        pathname: "/order-success",
        state: {
          payment,
          items: order.products,
          shipping: order.shipping,
          delivery_date: order.delivery_date,
          delivery_time: order.delivery_time,
          orderTotal: total,
          symbol,
        },
      });
    } else {
      props.history.push({
        pathname: "/order-success",
        state: {
          payment,
          items: order.products,
          shipping: order.shipping,
          delivery_date: order.delivery_date,
          delivery_time: order.delivery_time,
          orderTotal: total,
          symbol,
        },
      });
    }
  };

  const client = {
    sandbox: "AZ4S98zFa01vym7NVeo_qthZyOnBhtNvQDsjhaZSMH-2_Y9IAJFbSD3HPueErYqN8Sa8WYRbjP7wWtd_",
    production: "AZ4S98zFa01vym7NVeo_qthZyOnBhtNvQDsjhaZSMH-2_Y9IAJFbSD3HPueErYqN8Sa8WYRbjP7wWtd_",
  };

  const getPrice = (symbol, item) => {
    const price = item.seller_price
        - (item.product && item.product.discount
          ? (item.seller_price * (parseInt(item.product.discount, 10) / 100)) : 0);
    return (
      <Typography variant="caption" gutterBottom>
        {symbol}
        {price}
        {item.product.discount && (
          <del>
            <span className="money">
              {symbol}
              {item.seller_price}
            </span>
          </del>
        )}
      </Typography>
    );
  };

  const renderOrderItems = () => (
    <Box>
      <Card className="p-3">
        {cartItems.map((item, index) => (
          <Box className="styled-card" width="100%" display="flex" p={1}>
            <Box width="15%" order={1}>
              <img
                alt=""
                className="img-product"
                src={getImage(item.product.images)}
              />
            </Box>
            <Box width="85%" className="ml-1" order={2} display="flex">
              <Box flexGrow={1}>
                <Typography className="styled-link" gutterBottom variant="h6" component="p">
                  {item.product.name}
                </Typography>
                {getPrice(symbol, item)}
              </Box>
            </Box>
          </Box>
        ))}
      </Card>
    </Box>
  );

  const renderShippingAddress = () => (
    <Card variant="outlined" sx={{ mb: 3 }}>
      <CardHeader 
        avatar={<LocalShippingIcon sx={{ color: 'primary.main' }} />} 
        title="Delivery Details" 
        titleTypographyProps={{ fontWeight: 600 }} 
        sx={{ bgcolor: 'grey.200' }} 
      />
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>Delivery Schedule</Typography>
        <Typography variant="body2" gutterBottom fontWeight={600}>
           {getLocalDate(delivery_date, DATE_FORMAT)} | {getTimeSlot(delivery_time)}
        </Typography>
        
        <Divider sx={{ my: 2 }} />
        
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>Shipping Address</Typography>
        <Typography fontWeight={600}>{shipping.name}</Typography>
        <Typography variant="body2">{shipping.address}, {shipping.city}, {shipping.pincode}</Typography>
        <Typography variant="body2">{shipping.phone || ""}</Typography>
      </CardContent>
    </Card>
  );

  const renderShopPickup = () => (
    <Card variant="outlined" sx={{ mb: 3 }}>
       <CardHeader 
        avatar={<StorefrontIcon sx={{ color: 'primary.main' }} />} 
        title="Pickup Details" 
        titleTypographyProps={{ fontWeight: 600 }} 
        sx={{ bgcolor: 'grey.200' }} 
      />
      <CardContent>
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>Pickup Schedule</Typography>
        <Typography variant="body2" fontWeight={600}>
           {getLocalDate(delivery_date, DATE_FORMAT)} | {getTimeSlot(delivery_time)}
        </Typography>
      </CardContent>
    </Card>
  );

  const renderOrderTotal = () => (
    <Card variant="outlined">
      <CardHeader 
        avatar={<ReceiptLongIcon sx={{ color: 'primary.main' }} />} 
        title="Order Summary" 
        titleTypographyProps={{ fontWeight: 600 }} 
        sx={{ bgcolor: 'grey.200' }} 
      />
      <CardContent>
        <Box display="flex" justifyContent="space-between" mb={1}>
          <Typography color="text.secondary">Subtotal</Typography>
          <Typography>{symbol}{total_price}</Typography>
        </Box>
        <Box display="flex" justifyContent="space-between" mb={1}>
          <Typography color="text.secondary">Delivery</Typography>
          <Typography>{shippingoption === "actualcost" ? "To be Added" : `${symbol}${total_shipping}` }</Typography>
        </Box>
        <Box display="flex" justifyContent="space-between" mb={1}>
          <Typography color="text.secondary">Taxes</Typography>
          <Typography>{symbol}{total_tax}</Typography>
        </Box>
        
        <Divider sx={{ my: 2 }} />
        
        <Box display="flex" justifyContent="space-between" mb={2}>
          <Typography variant="h6" fontWeight={700}>Total</Typography>
          <Typography variant="h6" fontWeight={700} color="primary.main">{symbol}{total_order}</Typography>
        </Box>
        
        {shippingoption === "actualcost" && (
            <Typography variant="caption" color="error" align="center" display="block" gutterBottom>
                * Pending Delivery Charges. Will be added after order confirmation.
            </Typography>
        )}
        
        <ButtonComponent
            variant="contained"
            type="primary"
            name="Place Order"
            fullWidth
            size="large"
            onClick={() => handlePlaceOrder()}
        />
      </CardContent>
    </Card>
  );

  const paymentOptions = [
    { label: "Direct to Shop (UPI)", value: "upibased" },
    { label: "Cash on Delivery - CoD", value: "codbased" },
    { label: "Pay via Shopana (UPI/Credit Card)", value: "viagateway" },
  ];

  const allowedByShop = shopinfo.paymentoption ? paymentOptions.filter(item => shopinfo.paymentoption.includes(item.value)) : [];
  const availablePaymentOptions = order_type === "pickup"
      ? allowedByShop.filter((item) => item.value !== "codbased")
      : allowedByShop;

  const inputPaymentOptions = availablePaymentOptions.map((item) => {
    const { label, value } = item;
    return (
      <FormControlLabel value={value} control={<Radio />} label={label} />
    );
  });

  return (
    <div>
      {isLoading && <Pace color="#27ae60" height="2px" progressbar="2px" />}
      {
        ((order_type === "delivery" && address) || (order_type === "pickup"))
          ? (
            <form>
              <Container sx={{ py: 3 }}>
                <Grid container spacing={3}>
                    <Grid item xs={12} md={8}>
                        {/* Delivery/Pickup Review */}
                        {order_type === "delivery" ? renderShippingAddress() : renderShopPickup()}
                        
                        {/* Payment Options */}
                        <Card variant="outlined" sx={{ mb: 3 }}>
                            <CardHeader 
                                avatar={<PaymentIcon sx={{ color: 'primary.main' }} />} 
                                title="Payment Method" 
                                titleTypographyProps={{ fontWeight: 600 }} 
                                sx={{ bgcolor: 'grey.200' }} 
                            />
                            <CardContent>
                                <RadioButtonFieldComponent
                                  required
                                  options={inputPaymentOptions}
                                  label="paymentoption"
                                  value={state.paymentoption}
                                  onChange={(event) => handlePaymentOption(event)}
                                />
                            </CardContent>
                        </Card>
                    </Grid>
                    
                    <Grid item xs={12} md={4}>
                        <Box sx={{ position: 'sticky', top: 20 }}>
                            {renderOrderTotal()}
                        </Box>
                    </Grid>
                </Grid>
              </Container>
            </form>
          )
          : (
              <section className="p-0">
                <div className="container">
                  <div className="row">
                    <div className="col-sm-12">
                      <div className="error-section">
                        <h1>404</h1>
                        <h2>page not found</h2>
                        <a href="/" className="btn btn-solid">back to home</a>
                      </div>
                    </div>
                  </div>
                </div>
              </section>
          )
      }
    </div>
  );
};

// Mapping Props and State.
const shopPaymentCheckout = connect(
  ({ cartList, bootupInfo, userproducts }) => ({
    bootupInfo,
    symbol: bootupInfo.symbol,
    shopinfo: bootupInfo.shopinfo,
    reqStatus: cartList.reqStatus,
    isLoading: cartList.isLoading,
    serviceError: cartList.serviceError,
    serviceCode: cartList.serviceCode,
    cartItems: cartList.cart,
    order: cartList.order,
    total: getCartTotal(cartList.cart),
  }),
  (dispatch) => bindActionCreators({ ...Actions, ...ActionsBase }, dispatch),
)(ShopPaymentCheckout);

export { shopPaymentCheckout as default };
